module.exports = __webpack_public_path__ + "img/langtransportert_med_paavirkningsgrad.c4bf1a24.jpg";